export const VALID_FILTER_GROUPS = {
  NETWORK: 'network',
  RISK_AND_VEGETATION: 'riskAndVegetation',
  WORK_STATUS: 'workStatus',
  ANALYSIS_YEAR: 'analysisYear',
} as const;

type FilterGroupKey =
  (typeof VALID_FILTER_GROUPS)[keyof typeof VALID_FILTER_GROUPS];

interface NetworkFilterVisibility {
  networkSelector: boolean;
  groups: boolean;
  phase: boolean;
  voltage: boolean;
}

type BaseFilterConfig = {
  [K in FilterGroupKey]?: boolean;
};

export type FilterConfig = Omit<
  BaseFilterConfig,
  typeof VALID_FILTER_GROUPS.NETWORK
> & {
  [VALID_FILTER_GROUPS.NETWORK]?: boolean | Partial<NetworkFilterVisibility>;
};

const ALL_NETWORK_FILTERS_VISIBLE: NetworkFilterVisibility = {
  networkSelector: true,
  groups: true,
  phase: true,
  voltage: true,
};

const ALL_NETWORK_FILTERS_HIDDEN: NetworkFilterVisibility = {
  networkSelector: false,
  groups: false,
  phase: false,
  voltage: false,
};

export const getNetworkFilterVisibility = (
  config: FilterConfig | undefined
): NetworkFilterVisibility => {
  const networkConfig = config?.network;

  // No config or network explicitly true: show all
  if (networkConfig === undefined || networkConfig === true) {
    return ALL_NETWORK_FILTERS_VISIBLE;
  }

  // Explicitly disabled: hide all
  if (networkConfig === false) {
    return ALL_NETWORK_FILTERS_HIDDEN;
  }

  // Object config: only show fields explicitly set to true
  return {
    networkSelector: networkConfig.networkSelector === true,
    groups: networkConfig.groups === true,
    phase: networkConfig.phase === true,
    voltage: networkConfig.voltage === true,
  };
};
